import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container", "row", "destroy"]

  add(event) {
    event.preventDefault()
    const index = new Date().getTime()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, index)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-nested-form-target='row']")
    const destroyInput = row.querySelector("[data-nested-form-target='destroy']")
    if (destroyInput) {
      destroyInput.value = "1"
      row.hidden = true
    } else {
      row.remove()
    }
  }
}
